/* global videojs */
import '../styles/overlay-grid-menu.css';

export default function OverlayGridMenu(player, items, options = {}) {

    const overlay = document.createElement('div');
    overlay.className = 'vjs-overlay-menu';
    player.el().appendChild(overlay);

    const grid = document.createElement('div');
    grid.className = 'vjs-grid-menu';
    overlay.appendChild(grid);

    if (options.minTile) grid.style.setProperty('--min-tile', options.minTile);
    if (options.maxTile) grid.style.setProperty('--max-tile', options.maxTile);
    if (options.gap)     grid.style.setProperty('--gap',     options.gap);

    const close = () => {
        overlay.remove();
        document.removeEventListener('keydown', onKey);
    };
    overlay.addEventListener('click', e => { if (e.target === overlay || e.target === grid) close(); });
    const onKey = e => { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);

    items.forEach(item=>{
        const el = document.createElement('div');
        el.className = 'vjs-grid-item';
        el.setAttribute('tabindex','0');
        if(item.selected) el.classList.add('vjs-selected');

        const img = document.createElement('img');
        img.className = 'vjs-grid-thumb';
        img.src = item.thumb;
        el.appendChild(img);

        const span = document.createElement('span');
        span.className = 'vjs-grid-label';
        span.textContent = item.label;
        el.appendChild(span);

        const onSelect = () => { item.onSelect?.(); close(); };
        el.addEventListener('click', onSelect);
        el.addEventListener('keydown', e=>{
            if(e.key === 'Enter' || e.key === ' '){
                e.preventDefault(); onSelect();
            }
        });

        grid.appendChild(el);
    });

    return { close };
}